'use client';

import { createTheme } from '@mui/material/styles';
import breakpoints from './breakpoints';
import colors from './colors';
import typography from './typographyNew';

const arrowButtonStyle = {
  justifyContent: 'space-between',
  borderRadius: '100px',
  border: '2px solid',
  paddingInline: '30px',
  height: '53px',
  minWidth: 238,
  maxWidth: '100%',
  textTransform: 'none',
  ...typography.buttonLabel,
};

const menuButtonStyle = {
  justifyContent: 'center',
  borderRadius: '100px',
  border: '2px solid',
  paddingInline: '30px',
  height: '53px',
  minWidth: 178,
  maxWidth: '100%',
  textTransform: 'none',
  ...typography.buttonLabel,
};

const menuButtonStyleMobile = {
  height: '44px',
  minWidth: 'auto',
  maxWidth: '100%',
  ...typography.buttonLabel,
};

const buttonPrimaryStyle = {
  ...arrowButtonStyle,
  borderColor: colors.colorTheme.primaryColors.dark,
  '&:hover': {
    backgroundColor: colors.colorTheme.containerSecondaryOnLight,
  },
  '&:active': {
    backgroundColor: colors.colorTheme.primaryColors.white,
    borderColor: 'rgba(0, 42, 58, 0.50)',
  },
  '&.Mui-disabled': {
    borderColor: colors.colorTheme.strokeDisabledOnLight,
    color: colors.colorTheme.strokeDisabledOnLight,
  },
};

const buttonSecondaryStyle = {
  ...arrowButtonStyle,
  borderColor: 'transparent',
  backgroundColor: colors.colorTheme.primaryColors.white,
  '&:hover': {
    backgroundColor: 'rgba(64, 95, 107, .5)',
  },
  '&:focus': {
    backgroundColor: 'rgba(40, 57, 61, 0.15)',
    borderColor: colors.colorTheme.buttonFocusBorder,
  },
  '&:active': {
    backgroundColor: 'rgba(40, 57, 61, 0.15)',
    borderColor: 'transparent',
  },
  '&.Mui-disabled': {
    borderColor: 'transparent',
    backgroundColor: colors.colorTheme.containerDisabled,
    color: colors.colorTheme.strokeDisabledOnLight,
  },
};

const menuButtonWhite = {
  ...menuButtonStyle,
  borderColor: colors.colorTheme.primaryColors.white,
  backgroundColor: colors.colorTheme.primaryColors.white,
  '&:hover': {
    backgroundColor: colors.colorTheme.containerSecondaryOnLight,
  },
};

const menuButtonDark = {
  ...menuButtonStyle,
  borderColor: colors.colorTheme.primaryColors.dark,
  backgroundColor: colors.colorTheme.primaryColors.dark,
  color: colors.colorTheme.primaryColors.white,
  '&:hover': {
    backgroundColor: colors.colorTheme.containerSecondaryOnLight,
    color: colors.colorTheme.primaryColors.dark,
  },
};

const menuButtonWhiteMobile = {
  ...menuButtonStyle,
  ...menuButtonStyleMobile,
  borderColor: colors.colorTheme.primaryColors.white,
  backgroundColor: 'transparent',
  color: colors.colorTheme.primaryColors.white,
  '&:hover': {
    backgroundColor: colors.colorTheme.containerSecondaryOnLight,
    color: colors.colorTheme.primaryColors.dark,
  },
};

const menuButtonDarkMobile = {
  ...menuButtonStyle,
  ...menuButtonStyleMobile,
  borderColor: colors.colorTheme.primaryColors.dark,
  backgroundColor: 'transparent',
  color: colors.colorTheme.primaryColors.dark,
  '&:hover': {
    backgroundColor: colors.colorTheme.containerSecondaryOnLight,
    color: colors.colorTheme.primaryColors.dark,
  },
};

const theme = createTheme({
  breakpoints,
  typography,
  palette: {
    ...colors,
  },
  components: {
    MuiButton: {
      variants: [
        {
          props: { variant: 'primary' },
          style: { ...buttonPrimaryStyle },
        },
        {
          props: { variant: 'primary-full' },
          style: { ...buttonPrimaryStyle, width: '100% !important' },
        },
        {
          props: { variant: 'secondary' },
          style: { ...buttonSecondaryStyle },
        },
        {
          props: { variant: 'secondary-full' },
          style: { ...buttonSecondaryStyle, width: '100% !important' },
        },
        {
          props: { variant: 'menu-white' },
          style: { ...menuButtonWhite },
        },
        {
          props: { variant: 'menu-dark' },
          style: { ...menuButtonDark },
        },
        {
          props: { variant: 'menu-white-mobile' },
          style: { ...menuButtonWhiteMobile },
        },
        {
          props: { variant: 'menu-dark-mobile' },
          style: { ...menuButtonDarkMobile },
        },
      ],
    },
  },
});

export default theme;
